import React from 'react'

import AgendamentoMensageriaFormPageContainer from './AgendamentoMensageriaFormPageContainer'

export class AgendamentoMensageriaFormPage extends React.Component {
  render() {
    return <AgendamentoMensageriaFormPageContainer {...this.props} />
  }
}
